export class mail {
   
    idTributoContribuyente:string;
    email:string;
    idJurisdiccion:number;
    usrMod:string;
}